import { createRouter, createWebHistory } from 'vue-router';
import Login from '@/components/auth/login.vue';
import Register from '@/components/auth/register.vue';
import Course from '@/components/courses/course.vue';
import TripsEntry from '@/components/trips/index.vue';
import Trips from '@/components/trips/trips.vue';
import Trip from '@/components/trips/trip.vue';
import TripSwap from '@/components/trip-swap/index.vue';
import SharedTrip from '../components/trips/shared-trip.vue';
import Chapter from '@/components/courses/chapter.vue';
import HotelEntry from '@/components/hotels/index.vue';
import HotelSearch from '@/components/hotels/search/index.vue';
import HotelProperty from '@/components/hotels/property/property.vue';
import Alerts from '@/components/alerts/alerts.vue';
import Favorites from '@/components/hotels/favorites/favorites.vue';
import LoungeFavorites from '@/components/tools/lounges/lounge-favorites/index.vue';
import LoungesEntry from '@/components/tools/lounges/index.vue';
import Lounges from '@/components/tools/lounges/lounges.vue';
import LoungesSearch from '@/components/tools/lounges/lounges-search/lounges-search/index.vue';
import LoungeWizard from '@/components/tools/lounges/lounge-wizard/index.vue';
import Lounge from '@/components/tools/lounges/lounge/index.vue';
import TravelMembers from '../components/travel-plus/travel-members.vue';
import TravelPlusExperience from '@/components/travel-plus/travel-experience.vue';
import TravelPlus from '@/components/travel-plus/index.vue';
import TravelPlusDashboard from '@/components/travel-plus/travel-plus-dashboard.vue';
import TravelPlusSubscriptionSuccess from '@/components/travel-plus/subscription-success.vue';
import SsoCallback from '../components/auth/sso-callback.vue';
import UnresolvedAccounts from '@/components/admin/unresolved-accounts/index.vue';
import { useAppStore } from '@/store/app';

import travelPlus from '@/middleware/travel-plus';

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { title: 'Login' },
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: { title: 'Register' },
    },
    {
        path: '/10xtravel-plus',
        name: 'TravelPlus',
        component: TravelMembers,
        meta: {
            middleware: 'travelPlus',
            title: '10xTravel+',
            breadcrumb: '10xTravel+',
        },
    },
    {
        path: '/10xtravel-plus/upgrade',
        name: 'TravelPlusExperience',
        component: TravelPlusExperience,
        meta: { title: 'Experience', breadcrumb: 'Experience' },
    },
    {
        path: '/10xtravel-plus/subscription-start',
        name: 'TravelPlusSubscriptionSuccess',
        component: TravelPlusSubscriptionSuccess,
        meta: { title: 'Get Started', breadcrumb: 'Get Started' },
    },
    /*{
        path: '/courses',
        name: 'Courses',
        component: Courses,
        meta: { title: 'Courses', breadcrumb: 'Courses' },
    },*/
    /*{
        path: '/courses/:slug',
        name: 'Course',
        component: Course,
        meta: { title: 'Course', breadcrumb: 'slug' },
        children: [
            {
                path: 'chapters/:chapterSlug',
                name: 'Chapter',
                component: Chapter,
                meta: { title: 'Chapter', breadcrumb: 'chapterSlug' },
            },
        ],
    },
    */
    /*{
        path: '/course',
        name: 'Courses',
        component: Courses,
        meta: { title: 'Courses', breadcrumb: 'Courses' },
    },*/
    {
        path: '/course',
        name: 'Course',
        component: Course,
        meta: { title: 'Course', breadcrumb: 'slug' },
        children: [
            {
                path: 'chapters/:chapterSlug',
                name: 'Chapter',
                component: Chapter,
                meta: { title: 'Chapter', breadcrumb: 'chapterSlug' },
            },
        ],
    },
    {
        path: '/trip/shared/:tripUuid',
        name: 'SharedTrip',
        component: SharedTrip,
        meta: { title: 'Shared Trip', breadcrumb: 'Shared Trip' },
    },
    {
        path: '/trips',
        name: 'TripsEntry',
        component: TripsEntry,
        meta: { title: 'Trips', breadcrumb: 'Trips' },
        children: [
            {
                path: ':tripUuid',
                name: 'Trip',
                component: Trip,
                meta: { title: 'Trip', breadcrumb: 'Trip' },
            },
            {
                path: ':tripUuid/redemptions',
                name: 'Redemptions',
                component: Trips,
                meta: { title: 'Redemptions', breadcrumb: 'Redemptions' },
            },
        ],
    },
    {
        path: '/hotels',
        name: 'Hotels',
        component: HotelEntry,
        meta: { title: 'Hotels', breadcrumb: 'Hotels' },
        children: [
            {
                path: 'search',
                name: 'HotelSearch',
                component: HotelSearch,
                meta: {
                    title: 'Hotel Search',
                    breadcrumb: 'Search',
                    showBackToFavorites: false,
                },
            },
            {
                path: 'properties/:slug',
                name: 'HotelProperty',
                component: HotelProperty,
                meta: {
                    title: 'Hotel Property',
                    breadcrumb: 'slug',
                },
            },
            {
                path: 'favorites',
                name: 'Favorites',
                component: Favorites,
                meta: {
                    title: 'Favorites',
                    breadcrumb: 'Favorites',
                    showBackToFavorites: true,
                },
            },
        ],
    },
    {
        path: '/alerts',
        name: 'Alerts',
        component: Alerts,
        meta: { title: 'Alerts', breadcrumb: 'Alerts' },
    },
    {
        path: '/lounges',
        name: 'LoungesEntry',
        meta: { title: 'Lounges', breadcrumb: 'Lounges' },
        component: LoungesEntry,
        children: [
            {
                path: '',
                name: 'Lounges',
                component: Lounges,
                meta: { title: 'Lounge Finder', breadcrumb: 'Lounge Finder' },
            },
            {
                path: 'search',
                name: 'LoungesSearch',
                component: LoungesSearch,
                meta: {
                    title: 'Lounge Search',
                    breadcrumb: 'Search',
                    showBackToFavorites: false,
                },
            },
            {
                path: 'wizard',
                name: 'LoungeWizard',
                component: LoungeWizard,
                meta: {
                    title: 'Lounge Wizard',
                    breadcrumb: 'Lounge Wizard',
                    showBackToFavorites: false,
                },
            },
            {
                path: 'details/:id',
                name: 'Lounge',
                component: Lounge,
                meta: {
                    title: 'Lounge',
                    breadcrumb: 'loungeId',
                },
            },
            {
                path: 'favorites',
                name: 'LoungeFavorites',
                component: LoungeFavorites,
                meta: {
                    title: 'Favorites',
                    breadcrumb: 'Favorites',
                    showBackToFavorites: true,
                },
            },
        ],
    },
    {
        path: '/trip-swap',
        name: 'TripSwap',
        component: TripSwap,
        meta: {
            title: 'Trip Swap',
            breadcrumb: 'Trip Swap'
        },
    },
    {
        path: '/admin/resolve-card-matches',
        name: 'unresolved-accounts',
        component: UnresolvedAccounts,
        meta: {
            title: 'Unresolved Accounts',
            breadcrumb: 'Unresolved Accounts',
        },
    },
    {
        path: '/admin/unresolved-accounts',
        name: 'UnresolvedAccounts',
        component: UnresolvedAccounts,
        meta: {
            title: 'Unresolved Accounts',
            breadcrumb: 'Unresolved Accounts',
        },
    },
    {
        path: '/admin/card-matches',
        name: 'admin.card-matches',
        component: () => import('../views/admin/card-matches/index.vue'),
        children: [
            {
                path: '',
                name: 'admin.card-matches.index',
                meta: { title: 'Card Matches - Admin' },
                component: () => import('../views/admin/card-matches/list.vue'),
            },
            {
                path: 'logs',
                name: 'admin.card-matches.logs',
                meta: { title: 'Card Matches Import Log - Admin' },
                component: () =>
                    import('../components/admin/card-matches/logs-table.vue'),
            },
        ],
    },
    {
        path: '/auth/:provider/callback',
        component: SsoCallback,
        name: 'sso-callback',
    },
];

const router = createRouter({
    history: createWebHistory('/'),
    linkExactActiveClass: 'active',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { left: 0, top: 0 };
    },
    routes,
});

// const previousRoute = ref(null);

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        context.next(...parameters);

        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    if (to.meta?.middleware?.travelPlus) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return travelPlus({ ...context, next: nextMiddleware });
        //return middleware[0]({ ...context, next: nextMiddleware });
    }

    const lastRoute = from.name || 'Hotels';
    localStorage.setItem('last_route', lastRoute);

    if (to.name) {
        document.title = to.meta.title + ' | My10x';
        localStorage.setItem('current_route', to.name);
    }

    const appStore = useAppStore();
    appStore.setPreviousRoute(from);

    next();
});

router.beforeResolve((to, from, next) => {
    next();
});

router.afterEach((to, from) => {
    if (window._hsq) {
        window._hsq.push(['setPath', to.fullPath])
        window._hsq.push(['trackPageView'])
    }
});

export default router;
